import { Controller } from "@hotwired/stimulus"
import { showBlock } from "lib/helpers"

// Widget tab controller for _edit_widget partial.
// Handles: enable/disable toggle, expand delay toggle, color picker, company name sync,
// logo uploads (company-logo, button-logo), URL validation, webhook secret reset.
export default class extends Controller {
  static values = {
    errorBlock: { type: String, default: "#chatbot-errors" },
  }

  connect() {
    this.initWidgetToggleHandler()
    this.initExpandDelayToggleHandler()
    this.initCompanyNameHandler()
    this.initColorPickerHandler()
    this.initUrlValidationHandler()
    this.initUploadImgHandler('company-logo')
    this.initUploadImgHandler('button-logo')
    this.initUploadImgHover('company-logo')
    this.initUploadImgHover('button-logo')
    this.initResetWidgetWebhookSecret()
  }

  initWidgetToggleHandler() {
    $("#chat_assistant_widget_enabled").on("change.editWidget", function () {
      if ($(this).prop('checked')) $(".widget-control-group").removeAttr('disabled')
      else $(".widget-control-group").attr('disabled', 'disabled')
    })
  }

  initExpandDelayToggleHandler() {
    $("#chat_assistant_widget_is_expand_delay_enabled").on("change.editWidget", function () {
      if ($(this).prop('checked')) $(".expand-delay-control-group").removeAttr('disabled')
      else $(".expand-delay-control-group").attr('disabled', 'disabled')
    })
  }

  initCompanyNameHandler() {
    $("#chat_assistant_widget_company_name").on("change.editWidget paste.editWidget keyup.editWidget", function () {
      const name = $(this).val()
      if (name.length > 0) $(".company_name").text(name)
    })
  }

  initColorPickerHandler() {
    $(".color-picker").on("input.editWidget change.editWidget", function () {
      const input = $("#widget_color")
      if (input.val() !== $(this).val()) { input.val($(this).val()); updateWidgetColorPreview() }
    })
    $("#widget_color").on("paste.editWidget keyup.editWidget", function () {
      const input = $(".color-picker")
      const isValid = $(this).val().match(/^\#([a-zA-Z0-9]){6}$/)
      if (input.val() !== $(this).val() && isValid) { input.val($(this).val()); updateWidgetColorPreview() }
    })

    function updateWidgetColorPreview() {
      const color = $("#widget_color").val()
      if (!color || !color.match(/^\#([a-zA-Z0-9]){6}$/)) return
      $(".conversation-header").css({ "border-color": color, "background-color": color })
      $(".outgoing .msg").css({ "border-color": color, "background-color": color })
      $(".msg-input-wrap").css("border-color", color)
      $(".icon-send").css("color", color); $(".icon-reset").css("color", color)
      $(".chatbot-interactive-reset").css("border-color", color)
      $(".button-logo-wrapper").css("background-color", color)
      $(".chatbot-interactive-voice").css("border-color", color)
      $(".icon-mic").css("color", color); $(".icon-stop").css("color", color)
      document.documentElement.style.setProperty('--current-widget-color', color)
    }
  }

  initUrlValidationHandler() {
    $('input[name="chat_assistant[widget][domain]"]').on("paste.editWidget keyup.editWidget", function () {
      if (!this.value.length) return
      try {
        const parser = new URL(this.value)
        this.setCustomValidity(parser.origin !== this.value ? "Invalid format" : "")
      } catch (_) { this.setCustomValidity("Invalid format") }
    })
  }

  initUploadImgHandler(entity) {
    const self = this
    $("input." + entity + "-input").on('change.editWidget', function () {
      if (this.disabled) { showBlock(self.errorBlockValue, "File upload not supported!"); return }
      if (this.files && this.files[0]) self.readImage(this.files[0], entity)
    })
  }

  readImage(file, entity) {
    const fileInput = $("input." + entity + "-input")
    const uploadedImage = $('.' + entity + '-uploaded-image')
    const currentImg = $('img#current-' + entity)
    const action = $('.' + entity + '-action')
    const targetImg = $('img.' + entity)
    const targetImgWrapper = $('.' + entity + '-wrapper')
    const errorBlock = this.errorBlockValue

    if (file.size > 1048576) { showBlock(errorBlock, "Image is too large (current: " + file.size + " Byte, max: 1MB (1048576)"); fileInput.val(""); return }
    if (file.size < 100) { showBlock(errorBlock, "Image is too small (current: " + file.size + " Byte, min: 100 Bytes"); fileInput.val(""); return }

    const self = this
    const reader = new FileReader(), image = new Image()
    reader.readAsDataURL(file)
    reader.onload = function (_file) {
      image.src = _file.target.result
      image.onload = function () {
        uploadedImage.removeClass('hide'); currentImg.attr('src', this.src)
        if (targetImg.length > 0) targetImg.attr('src', this.src)
        if (targetImgWrapper.length > 0) targetImgWrapper[0].dataset.buttonLogoUrl = this.src
        action.val('upload'); self.initUploadImgHover(entity)
      }
      image.onerror = function () { showBlock(errorBlock, 'Invalid file type: ' + file.type); fileInput.val("") }
    }
  }

  initUploadImgHover(entity) {
    const self = this, reload = $('.reload-' + entity)
    $('.' + entity + '-uploaded-image').on("mouseenter.editWidget", function () {
      reload.removeClass('hide'); $(this).off("mouseenter.editWidget"); self.initRemoveImage(entity)
    })
  }

  initRemoveImage(entity) {
    const self = this
    $('.reload-' + entity).on("mouseleave.editWidget", function () {
      $(this).addClass('hide'); $(this).off("mouseleave.editWidget click.editWidget"); self.initUploadImgHover(entity)
    }).on("click.editWidget", function () {
      const uploadedImage = $('.' + entity + '-uploaded-image'), currentImg = $('img#current-' + entity), fileInput = $("input." + entity + "-input"), action = $('.' + entity + '-action'), targetImg = $('img.' + entity)
      currentImg.attr('src', currentImg.data("default-url"))
      if (targetImg.length > 0) targetImg.attr('src', currentImg.data("default-url"))
      fileInput.val(""); action.val('delete')
      $(this).off("mouseleave.editWidget click.editWidget"); uploadedImage.off("mouseenter.editWidget"); uploadedImage.addClass('hide'); $(this).addClass('hide')
    })
  }

  initResetWidgetWebhookSecret() {
    const self = this
    $("#reset_widget_handover_webhook_secret").on('click.editWidget', function (e) {
      e.preventDefault()
      $.ajax({
        url: this.href, type: "POST", dataType: "JSON",
        success(response) { if (response.success) { $(".assistant_widget_handover_webhook_secret").val(response.webhook_secret); $(".signing-secret-copy").data("copy-value", response.webhook_secret) } else showBlock(self.errorBlockValue, response.message) },
        error() { showBlock(self.errorBlockValue, "An error occurred during request.") }
      })
    })
  }
}
